export const EditionCardsCarousel = (function () {
  let swiperInstance, prevButton, nextButton = null;
  let allSlides = []; // we need to store them for filtering 
  let SELECTORS = null; 

  function initSwiper() {
    const refContainer = document.querySelector(SELECTORS.refContainer); 
    const swiperWrapper = document.querySelector(SELECTORS.swiperWrapper);
    prevButton = document.querySelector(SELECTORS.prevButton);
    nextButton = document.querySelector(SELECTORS.nextButton);
    allSlides = Array.from(document.querySelectorAll('#edition-cards-section .swiper .swiper-slide'));

    if (!refContainer || !swiperWrapper || !prevButton || !nextButton) {
      console.error('Required elements not found');
      return null;
    }    
    
		const refRect = refContainer.getBoundingClientRect();
  	const offsetBefore = refRect.left;

    // Initialize Swiper
    const swiper = new Swiper(SELECTORS.swiper, {
      slidesPerView: "auto",
      spaceBetween: 16,
      freeMode: false,
      slidesOffsetBefore: offsetBefore,
      slidesOffsetAfter: 16,
      navigation: {
        nextEl: SELECTORS.nextButton,
       	prevEl: SELECTORS.prevButton,
      },
      watchOverflow: true,
    });

	swiperInstance = swiper;

    // Set initial state of buttons
    updateButtonsState();

    // Add event listeners to update button states when slides change
    swiper.on('slideChange', updateButtonsState);
    
    // Add resize event listener separately
    window.addEventListener('resize', () => {
      const newOffsetBefore = refContainer.getBoundingClientRect().left;

      // Check if Swiper instance exists and has a method to update params
      if (swiper && swiper.params) {
        swiper.params.slidesOffsetBefore = newOffsetBefore;
        swiper.update(); // Refresh Swiper
      }
    });

    return swiper;
  }

  // Function to update button states
  function updateButtonsState() {
  	if (!prevButton || !nextButton) return;
    
    prevButton.style.opacity = swiperInstance.isBeginning ? '0.5' : '1';
    prevButton.style.pointerEvents = swiperInstance.isBeginning ? 'none' : 'auto'; 

    //nextButton.style.opacity = swiperInstance.isEnd ? '0.5' : '1';
    //nextButton.style.pointerEvents = swiperInstance.isEnd ? 'none' : 'auto';
    // Get Swiper's max translate position
    const maxTranslate = swiperInstance.maxTranslate();
    const currentTranslate = swiperInstance.translate;

    if (currentTranslate <= maxTranslate + 5) { // buffer of 5 to prevent minor calculation errors.
      nextButton.style.opacity = '0.5';
      nextButton.style.pointerEvents = 'none';
    } else {
      nextButton.style.opacity = '1';
      nextButton.style.pointerEvents = 'auto';
    }
  }

  // Public methods
  return {
    init: function(selectors) {
      SELECTORS = selectors;
      document.addEventListener('DOMContentLoaded', function() {
      	const swiperWrapper = document.querySelector(SELECTORS.swiperWrapper);
        swiperWrapper.style.gap = '0';
      	
        // Initialize swiper
        initSwiper();
      });
    },
    filterSeason(season) {
    	if (!swiperInstance) return;
      
    	// Collect slides to keep
     	const slidesToKeep = allSlides.filter(slideEl => 
     		season === 'all' || 
     		season === slideEl.getAttribute('data-season')
     	);
      
      swiperInstance.removeAllSlides();

      // Add filtered slides
      swiperInstance.addSlide(0, slidesToKeep);

      // Reset to first slide
      swiperInstance.slideTo(0, 0, false);
      
      updateButtonsState();
    }
  };
})();


// loop through all edition cards and add the edition query param to all URLs
// because we are linking to a destination page and want to pre-set the edition dropdown 
export function updateEditionCardLinkUrls() {
	const allEditionCards = document.querySelectorAll("#edition-cards-section .edition-card-item");
  
  allEditionCards.forEach((editionCard) => {
  	const editionLinkElems = editionCard.querySelectorAll("a"); // we defined the card multiple times in the collection item
    const editionSlug = editionCard.getAttribute("data-editionslug");
    const bookingState = editionCard.getAttribute("data-bookingstate");

    editionLinkElems.forEach((link) => {
    	// remove link from card and give bg less opacity for booking state "available soon"
    	if (bookingState == "Available Soon") {
     		link.setAttribute("href", "#");
        link.style.cursor = "auto";
        
        const bgImage = link.querySelector(".edition-card-image");
        bgImage.style.opacity = 0.4;
      } else if (editionSlug) {
        const baseUrl = link.getAttribute("href").split("?")[0]; // Remove existing query params
        // Update the link's href with the new query parameter
        link.setAttribute("href", `${baseUrl}?edition=${encodeURIComponent(editionSlug)}`);
      }
    });
  });
}
